export default __webpack_public_path__ + "static/media/confirmare.c729a965.svg";